import React from "react";
import "./Logo.css";

// Brand mark: a gold lightbulb spark on a navy tile
export const LogoMark = ({ size = 36 }) => (
  <svg
    className="logo-mark"
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    aria-hidden="true"
  >
    <rect width="40" height="40" rx="11" fill="#0B1B3F" />
    <path
      d="M20 9.5a7.5 7.5 0 0 0-4.4 13.58c.6.44.9 1.1.9 1.82V26h7v-1.1c0-.72.3-1.38.9-1.82A7.5 7.5 0 0 0 20 9.5Z"
      fill="#F5B53D"
    />
    <rect x="16.5" y="27.5" width="7" height="2.4" rx="1.2" fill="#F5B53D" opacity="0.7" />
    <path d="M18.2 18.6 20 16.4l1.8 2.2" stroke="#0B1B3F" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 16.6v6.2" stroke="#0B1B3F" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="31" cy="9" r="2" fill="#FFFFFF" opacity="0.9" />
  </svg>
);

const Logo = ({ size = 36, light = false }) => (
  <span className={`eg-logo ${light ? "eg-logo-light" : ""}`}>
    <LogoMark size={size} />
    <span className="eg-logo-text">
      MyEdu<span className="eg-logo-accent">Genius</span>
    </span>
  </span>
);

export default Logo;
